import { c as _c } from "react/compiler-runtime";
import { ReadMoreButton } from '@/app/(marketing-site)/_components/ReadMoreButton';
import { SkillBadge } from '@/app/(marketing-site)/(portfolio)/_components/SkillBadge';
import type { TagGeneralSkillLevel } from '@/common/enums';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { H3 } from '@/frontend/design-system/typography/Heading';
import { P2 } from '@/frontend/design-system/typography/Paragraph';
type Course = {
  name: string;
  description: string;
  skills: {
    name: string;
    level: TagGeneralSkillLevel;
  }[];
};
type CourseCardProps = {
  course: Course;
};
export function CourseCard(t0) {
  const $ = _c(19);
  const {
    course
  } = t0;
  let t1;
  if ($[0] !== course.skills) {
    t1 = course.skills.map(_temp);
    $[0] = course.skills;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-row flex-wrap gap-2">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== course.name) {
    t3 = <H3>{course.name}</H3>;
    $[4] = course.name;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== course.description) {
    t4 = <P2 className="text-contentTertiary">{course.description}</P2>;
    $[6] = course.description;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="space-y-3">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `/kursy/${course.name}`;
  let t7;
  if ($[11] !== t6) {
    t7 = <ReadMoreButton href={t6} title={"Szczeg\xF3\u0142y kursu"} className="font-medium text-sm" />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <div className="flex flex-1 flex-col justify-between gap-4">{t5}{t7}</div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t8) {
    t9 = <LightCard className="flex w-full flex-col space-y-4 p-6 shadow-sm sm:h-full">{t2}{t8}</LightCard>;
    $[16] = t2;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
function _temp(skill) {
  return <SkillBadge key={skill.name} skill={skill.name} />;
}